<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_ix"></a>CONTENTS</h2>
<p class="toc"><a href="#/Text/foreword">Foreword</a></p>
<p class="toc1"><em>Pat Conroy</em></p>
<p class="toc"><a href="#/Text/prologue">Prologue</a></p>
<p class="toc2"><a href="#/Text/part1">PART I: DAUGHTER OF MOTION</a></p>
<p class="toc3"><a href="#/Text/chapter01">High Tide and High Time</a></p>
<p class="toc3"><span href="#/Text/chapter02" title="Link target outside of Sample">The Edge of Heaven</span></p>
<p class="toc3"><span href="#/Text/chapter03" title="Link target outside of Sample">Pass by Home</span></p>
<p class="toc2"><span href="#/Text/part2" title="Link target outside of Sample">PART II: SOMEBODY ELSE’S SONG</span></p>
<p class="toc3"><span href="#/Text/chapter04" title="Link target outside of Sample">Chances Are</span></p>
<p class="toc3"><span href="#/Text/chapter05" title="Link target outside of Sample">Barrow</span></p>
<p class="toc3"><span href="#/Text/chapter06" title="Link target outside of Sample">Winter Songs</span></p>
<p class="toc3"><span href="#/Text/chapter07" title="Link target outside of Sample">Bearing Straight</span></p>
<p class="toc3"><span href="#/Text/chapter08" title="Link target outside of Sample">Delicate Bones</span></p>
<p class="toc3"><span href="#/Text/chapter09" title="Link target outside of Sample">Crossing the Divide</span></p>
<p class="toc3"><span href="#/Text/chapter10" title="Link target outside of Sample">Another Time</span></p>
<p class="toc2"><span href="#/Text/part3" title="Link target outside of Sample">PART III: DILIGENT RIVER</span></p>
<p class="toc3"><span href="#/Text/chapter11" title="Link target outside of Sample">Slow Curving Destiny</span></p>
<p class="toc3"><span href="#/Text/chapter12" title="Link target outside of Sample">Further Reaches</span></p>
<p class="toc3t"><span href="#/Text/chapter13" title="Link target outside of Sample">Acknowledgments</span><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?021d03f9